const baseTheme = {
  fonts: {
    mono: "'Futura PT',-apple-system,'BlinkMacSystemFont','Segoe UI','Roboto','Helvetica Neue','Arial','Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji'",
  },
};

const lightTheme = {
  ...baseTheme,
  colors: {
    background: '#fff',
    heading: '#000',
    text: '#4b4b4b',
    textGrey: '#77756E',
    preFormattedText: 'rgb(245, 247, 249)',
    link: '#682BD3',
  },
};

const darkTheme = {
  ...baseTheme,
  colors: {
    background: '#001933',
    heading: '#fff',
    text: '#fff',
    textGrey: '#77756E',
    preFormattedText: '#000',
    link: '#682BD3',
  },
};

export { lightTheme, darkTheme };
